var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedTestIconPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2302_7518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2302_7518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.27098 17.5C2.11821 17.5 1.97932 17.4618 1.85432 17.3854C1.72932 17.309 1.63209 17.2083 1.56265 17.0833C1.49321 16.9583 1.45501 16.8229 1.44807 16.6771C1.44112 16.5312 1.47932 16.3889 1.56265 16.25L9.27098 2.91667C9.35432 2.77778 9.46196 2.67361 9.5939 2.60417C9.72584 2.53472 9.86126 2.5 10.0001 2.5C10.139 2.5 10.2745 2.53472 10.4064 2.60417C10.5383 2.67361 10.646 2.77778 10.7293 2.91667L18.4377 16.25C18.521 16.3889 18.5592 16.5312 18.5522 16.6771C18.5453 16.8229 18.5071 16.9583 18.4377 17.0833C18.3682 17.2083 18.271 17.309 18.146 17.3854C18.021 17.4618 17.8821 17.5 17.7293 17.5H2.27098ZM10.0001 15C10.2363 15 10.4342 14.9201 10.5939 14.7604C10.7536 14.6007 10.8335 14.4028 10.8335 14.1667C10.8335 13.9306 10.7536 13.7326 10.5939 13.5729C10.4342 13.4132 10.2363 13.3333 10.0001 13.3333C9.76404 13.3333 9.56612 13.4132 9.4064 13.5729C9.24668 13.7326 9.16682 13.9306 9.16682 14.1667C9.16682 14.4028 9.24668 14.6007 9.4064 14.7604C9.56612 14.9201 9.76404 15 10.0001 15ZM10.0001 12.5C10.2363 12.5 10.4342 12.4201 10.5939 12.2604C10.7536 12.1007 10.8335 11.9028 10.8335 11.6667V9.16667C10.8335 8.93056 10.7536 8.73264 10.5939 8.57292C10.4342 8.41319 10.2363 8.33333 10.0001 8.33333C9.76404 8.33333 9.56612 8.41319 9.4064 8.57292C9.24668 8.73264 9.16682 8.93056 9.16682 9.16667V11.6667C9.16682 11.9028 9.24668 12.1007 9.4064 12.2604C9.56612 12.4201 9.76404 12.5 10.0001 12.5Z",
    fill: "#F75676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTestIconPink);
export default __webpack_public_path__ + "static/media/FailedTestIconPink.9d105b71d09d360249e9ce4cdc9de512.svg";
export { ForwardRef as ReactComponent };